import { useSettingsContext } from 'src/components/settings/context';

// Single source of truth: proxy to the app SettingsContext hook
const useSettings = () => useSettingsContext();

export default useSettings;
